export const scoreToEmoji = (score: number) => {
  if (score >= 2) return '😄' // +2
  if (score > 0 && score < 2) return '🙂' // +1
  if (score > -2 && score <= 0) return '😕' // -1
  return '😠' // -2 or less
}
